export enum ApiKeysPersonalEmptyVariant {
  TURNED_OFF = "TURNED_OFF",
  NO_KEYS = "NO_KEYS",
}
